<template>
  <div>
    <div>
      <contrato></contrato>
    </div>
  </div>
</template>

<script>
import contrato from '@/components/contrato/contrato.vue'
  export default {
    name: 'firma',
    components: {
      contrato
    },
    data: () => ({
      contratoShow: false,
      myImage: require('@/assets/icon.png'),
    }),
    methods:{
      showContrato(){
        this.contratoShow = !this.contratoShow;
      },
    }
  }
</script>
